<!--报警接收者对象 右键属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="objStatus ? name + '-报警接收者-邮件' : '新建' + '-报警接收者-邮件'" class="my-test-class" @close="close"
      @confirm="handleConfirm">

      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <gs-form :model="form">
            <gs-form-item v-if="objectData.type !== 'alarmReceiverEmail'" label="名称" prop="target"
              class="form-item-radio" style="width:423px;">
              <gs-input ref="nameInput" v-model="name" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio" style="width:423px;">
              <gs-input v-model="description" />
            </gs-form-item>
            <div>
              <fieldset>
                <legend>邮件设置</legend>
                <gs-form-item label="接收报警的邮件地址" prop="target" class="form-item-radio">
                  <gs-input v-model="email" />
                </gs-form-item>
                <gs-form-item label="邮件主题" prop="target" class="form-item-radio">
                  <gs-input v-model="title" />
                </gs-form-item>
              </fieldset>
            </div>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="报警字段" name="second">
          <div>
            <fieldset>
              <legend>邮件参数</legend>
              <span>请选择要显示在邮件中的报警字段：</span>
              <gs-checkbox v-model="form.Priority" class="checkbox-block">优先级</gs-checkbox>
              <gs-checkbox v-model="form._Event" class="checkbox-block">事件</gs-checkbox>
              <gs-checkbox v-model="form.LastChange" class="checkbox-block">最后变化时间</gs-checkbox>
              <gs-checkbox v-model="form.ObjectId" class="checkbox-block">对象id</gs-checkbox>
              <gs-checkbox v-model="form._Text" class="checkbox-block">报警信息</gs-checkbox>
            </fieldset>
          </div>
        </gs-tab-pane>
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <gs-button type="primary" size="mini" @click="dialogHelp = true">帮 助</gs-button>
      </span>
    </gs-modal>
    <gs-modal title="帮助-报警接收者-邮件" v-model="dialogHelp" class="my-test-class" :before-close="handleCloseHelp">
      <span class="tab">常规</span><br>
      <hr />
      <span class="tit">名称：</span><span class="txt">实时曲线图对象的名称</span><br>
      <span class="tit">描述：</span><span class="txt">对该对象的描述</span><br>
      <span class="tit">邮件设置</span><span class="txt"></span><br>
      <span class="tit">接收报警的邮件地址：</span><span class="txt">请填写正确的邮箱地址</span><br>
      <span class="tit">邮件主题：</span><span class="txt">请标明邮件的主题是什么</span><br>
      <span class="tab">报警字段</span><br>
      <hr />
      <span class="tit">邮件参数</span><span class="txt"></span><br>
      <span class="tit">请选择要显示在邮件中的报警字段：</span><span class="txt">优先级、事件、最后变化时间、对象id、报警信息</span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <!--<el-button @click="dialogHelp = false">取 消</el-button>
      <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->

    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
export default {
  components: {

  },
  data() {
    return {
      dialogHelp: false,
      objStatus: 0,
      loading: false,
      activeName: 'first',
      form: {
        Priority: '',
        _Event: '',
        LastChange: '',
        ObjectId: '',
        _Text: ''
      },
      email: '',
      title: '',
      description: '',
      name: ''
    }
  },
  computed: {
    ...mapState({
      visible: 'alarmChartDialogShow',
      objectData: 'objectInfo',
      nodeData: 'nodeTree'
    })
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData
    },
    visible() {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        if (JSON.stringify(this.objectData) !== '{}' && this.objectData.type === 'alarmReceiverEmail') {
          this.email = this.objectData.attribute.email ? this.objectData.attribute.email : ''
          this.title = this.objectData.attribute.title ? this.objectData.attribute.title : ''
          this.description = this.objectData.description ? this.objectData.description : ''
          this.name = this.objectData.name ? this.objectData.name : ''
          this.objStatus = 1
        } else {
          this.objStatus = 0
          this.activeName = 'first'
          this.form = {
            Priority: '',
            _Event: '',
            LastChange: '',
            ObjectId: '',
            _Text: ''
          }
          this.email = ''
          this.title = ''
          this.description = ''
          this.name = ''
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'ALARMCHART_PROPERTIES_DIALOG_HIDE',
      needReload: 'NEED_RELOAD_TREE'
    }),
    beforeClose() {
      this.close()
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      this.loading = true
      let array = []
      for (let i in this.form) {
        if (this.form[i] === true) {
          switch (i) {
            case 'Priority':
              this.form[i] = 'Priority'
              break
            case '_Event':
              this.form[i] = 'Event'
              break
            case 'LastChange':
              this.form[i] = 'Last change'
              break
            case 'ObjectId':
              this.form[i] = 'Object ID'
              break
            case '_Text':
              this.form[i] = 'Text'
              break
            default:
              delete this.form[i]
              break
          }
        }
      }
      for (let n in this.form) {
        if (this.form[n] !== '') {
          array.push(this.form[n])
        }
      }
      if (this.objectData.id && this.objectData.type === 'alarmReceiverEmail') {
        let param = {
          id: this.objectData.id,
          'name': this.name,
          'type': this.objectData.type,
          value: this.objectData.value,
          'parentId': this.objectData.parentId,
          'description': this.description,
          'attribute': {
            'email': this.email,
            'title': this.title,
            'alarmFields': array // 邮件内容中要显示的字段
          }
        }
        service.renamePoint(param).then(res => {
          this.loading = false
          this.$Message.success('修改成功')
          this.close()
        }).catch(err => {
          this.loading = false
          this.$Message.error(err.message)
        })
      } else {
        let param = {
          'name': this.name,
          'type': 'alarmReceiverEmail',
          'parentId': this.objectData.id,
          'description': this.description,
          'attribute': {
            'email': this.email,
            'title': this.title,
            'alarmFields': array // 邮件内容中要显示的字段
          }
        }
        console.log(param)
        service.newAddPoint(param).then(res => {
          this.loading = false
          this.$Message.success('添加成功')
          this.close()
        }).catch(err => {
          this.loading = false
          this.$Message.error(err.message)
        })
      }
    },
    onChange(v) {

    },
    add() {

    },
    del() {

    },
    yAxis() {

    },
    property() {

    },
    handleCloseHelp() {
      this.dialogHelp = false
    }
  }
}
</script>
<style scoped>
.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 45%;
  float: left;
  margin-right: 20px;
}

fieldset {
  padding: 10px;
}

.bottom-btn {
  margin: 20px;
  text-align: center
}

.checkbox-block {
  display: block;
  margin: 10px;
}

.tit {
  color: #ffffff;
}

.txt {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/alarmReceiver/alarmReceiver.vue